import { render, staticRenderFns } from "./TestAwardFrame.vue?vue&type=template&id=25337314"
import script from "./TestAwardFrame.vue?vue&type=script&lang=js"
export * from "./TestAwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25337314')) {
      api.createRecord('25337314', component.options)
    } else {
      api.reload('25337314', component.options)
    }
    module.hot.accept("./TestAwardFrame.vue?vue&type=template&id=25337314", function () {
      api.rerender('25337314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/test-award/components/TestAwardFrame.vue"
export default component.exports